module.exports = __webpack_public_path__ + "img/a.6b8e5d83.svg";